var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5C10.5 10.9142 10.1642 11.25 9.75 11.25C9.33579 11.25 9 10.9142 9 10.5C9 10.0858 9.33579 9.75 9.75 9.75C10.1642 9.75 10.5 10.0858 10.5 10.5Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 13.5C5.66421 13.5 6 13.1642 6 12.75C6 12.3358 5.66421 12 5.25 12C4.83579 12 4.5 12.3358 4.5 12.75C4.5 13.1642 4.83579 13.5 5.25 13.5Z",
    fill: "#0F172A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15C6 15.4142 5.66421 15.75 5.25 15.75C4.83579 15.75 4.5 15.4142 4.5 15C4.5 14.5858 4.83579 14.25 5.25 14.25C5.66421 14.25 6 14.5858 6 15Z",
    fill: "#0F172A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5C7.91421 13.5 8.25 13.1642 8.25 12.75C8.25 12.3358 7.91421 12 7.5 12C7.08579 12 6.75 12.3358 6.75 12.75C6.75 13.1642 7.08579 13.5 7.5 13.5Z",
    fill: "#0F172A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15C8.25 15.4142 7.91421 15.75 7.5 15.75C7.08579 15.75 6.75 15.4142 6.75 15C6.75 14.5858 7.08579 14.25 7.5 14.25C7.91421 14.25 8.25 14.5858 8.25 15Z",
    fill: "#0F172A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 13.5C10.1642 13.5 10.5 13.1642 10.5 12.75C10.5 12.3358 10.1642 12 9.75 12C9.33579 12 9 12.3358 9 12.75C9 13.1642 9.33579 13.5 9.75 13.5Z",
    fill: "#0F172A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15C10.5 15.4142 10.1642 15.75 9.75 15.75C9.33579 15.75 9 15.4142 9 15C9 14.5858 9.33579 14.25 9.75 14.25C10.1642 14.25 10.5 14.5858 10.5 15Z",
    fill: "#0F172A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5C12.4142 13.5 12.75 13.1642 12.75 12.75C12.75 12.3358 12.4142 12 12 12C11.5858 12 11.25 12.3358 11.25 12.75C11.25 13.1642 11.5858 13.5 12 13.5Z",
    fill: "#0F172A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15C11.25 14.5858 11.5858 14.25 12 14.25C12.4142 14.25 12.75 14.5858 12.75 15Z",
    fill: "#0F172A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 13.5C14.6642 13.5 15 13.1642 15 12.75C15 12.3358 14.6642 12 14.25 12C13.8358 12 13.5 12.3358 13.5 12.75C13.5 13.1642 13.8358 13.5 14.25 13.5Z",
    fill: "#0F172A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.5C12.75 10.9142 12.4142 11.25 12 11.25C11.5858 11.25 11.25 10.9142 11.25 10.5C11.25 10.0858 11.5858 9.75 12 9.75C12.4142 9.75 12.75 10.0858 12.75 10.5Z",
    fill: "#0F172A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.25C14.6642 11.25 15 10.9142 15 10.5C15 10.0858 14.6642 9.75 14.25 9.75C13.8358 9.75 13.5 10.0858 13.5 10.5C13.5 10.9142 13.8358 11.25 14.25 11.25Z",
    fill: "#0F172A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 0C4.91421 0 5.25 0.335786 5.25 0.75V2.25H14.25V0.75C14.25 0.335786 14.5858 0 15 0C15.4142 0 15.75 0.335786 15.75 0.75V2.25H16.5C18.1569 2.25 19.5 3.59315 19.5 5.25V16.5C19.5 18.1569 18.1569 19.5 16.5 19.5H3C1.34315 19.5 0 18.1569 0 16.5V5.25C0 3.59315 1.34315 2.25 3 2.25H3.75V0.75C3.75 0.335786 4.08579 0 4.5 0ZM18 9C18 8.17157 17.3284 7.5 16.5 7.5H3C2.17157 7.5 1.5 8.17157 1.5 9V16.5C1.5 17.3284 2.17157 18 3 18H16.5C17.3284 18 18 17.3284 18 16.5V9Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6840c49df672970bc05e577a1a0f604d.svg";
export { ForwardRef as ReactComponent };